import { useRef, useState } from "react";
import moment from "moment";

export const useExpenseList = (initialQuickExpense = [], ITEMS_PER_PAGE) => {
  const isFirstRender = useRef(true);
  const firstRender = isFirstRender.current;

  const initialData =
    firstRender && initialQuickExpense?.length
      ? initialQuickExpense.slice(0, ITEMS_PER_PAGE)
      : [];

  const [state, setState] = useState({
    isLoading: true,
    expenseList: initialData,
    totalPaid: 0,
    totalUnPaid: 0,
    totalExpenseFilterCount: 0,
    totalExpenseAmount: 0,
  });

  // Same helper as QuickSale
  const getDateRange = (date) => {
    return {
      start: date?.startDate
        ? moment(date.startDate).startOf("day").valueOf()
        : undefined,
      end: date?.endDate
        ? moment(date.endDate).endOf("day").valueOf()
        : undefined,
    };
  };

  // Same totals calculator
  const calculateTotals = (data) => {
    let totals = {
      totalFilteredCount: data?.length || 0,
      totalPaid: 0,
      totalUnPaid: 0,
      totalExpenseAmount: 0,
    };

    data.forEach((item) => {
      totals.totalExpenseAmount += item.amount;

      if (item.status === "paid") {
        totals.totalPaid += item.amount;
      } else {
        totals.totalUnPaid += item.amount - (item.advance_amount || 0);
      }
    });

    return totals;
  };

  const handleExpense = async ({
    business,
    filters,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    const { date, amount, category, method, sort, status, keywords } =
      filters || {};

    setState((prev) => ({ ...prev, isLoading: true }));

    const { start, end } = getDateRange(date);

    try {
      let totals = {};

      // TOTALS
      if (isCalculateTotal) {
        let rawData;

        if (firstRender) {
          rawData = initialQuickExpense;
        } else {
          const baseQuery = business.getExpense(
            start,
            end,
            keywords || "",
            status,
            undefined,
            undefined,
            undefined,
            amount,
            category,
            method,
          );

          rawData = await baseQuery.unsafeFetchRaw();
        }

        totals = calculateTotals(rawData);
      }

      // PAGINATION
      const paginatedItems = firstRender
        ? initialData
        : await business
            .getExpense(
              start,
              end,
              keywords || "",
              status,
              limit,
              offset,
              sort || "Newest",
              amount,
              category,
              method,
            )
            .fetch();

      const updatedList =
        offset > 0
          ? [...state.expenseList, ...paginatedItems]
          : paginatedItems;

      // IMPORTANT
      isFirstRender.current = false;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        expenseList: updatedList,
        ...(isCalculateTotal && {
          totalPaid: totals.totalPaid,
          totalUnPaid: totals.totalUnPaid,
          totalExpenseFilterCount: totals.totalFilteredCount,
          totalExpenseAmount: totals.totalExpenseAmount,
        }),
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { ...state, handleExpense };
};